@if (fnolRequest) {
  <cpf-fnol-request-details [fnolRequest]="fnolRequest"></cpf-fnol-request-details>
}
